import React from 'react'
import helpers from 'helpers'
import { makeStyles } from '@material-ui/core/styles'
import { colors } from '@material-ui/core'
import Tooltip from '@material-ui/core/Tooltip'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'inline-block',
    lineHeight: 0,
    padding: 5,
  },
  dot: {
    display: 'inline-block',
    width: 10,
    height: 10,
    borderRadius: 10,
  },
}))

const DotStatus = ({ statusName, statusTag, entity = '' }) => {
  const classes = useStyles()

  const getColor = entity => {
    const red = colors.red[500]
    const green = colors.green[500]
    const yellow = colors.yellow[700]
    const grey = colors.grey[500]

    const redBadges = ['canceled', 'overdue', 'reversed', 'canceled', 'error']
    const greyBadges = ['inactive', 'finished']
    const greenBadges = ['active', 'paid', 'issued']
    const yellowBadges = [
      'paused',
      'pending',
      'awaiting_payment',
      'awaiting_approval',
      'created',
      'pending_cancel',
      'pending_issued',
    ]

    if (entity === 'invoice') {
      return helpers.invoices.statusColor(statusTag)
    }

    if (entity === 'contract') {
      return helpers.contracts.statusColor(statusTag)
    }

    if (greyBadges.includes(statusTag)) {
      return grey
    }

    if (redBadges.includes(statusTag)) {
      return red
    }

    if (greenBadges.includes(statusTag)) {
      return green
    }

    if (yellowBadges.includes(statusTag)) {
      return yellow
    }
  }

  return (
    <Tooltip title={statusName} placement="top">
      <div className={classes.root}>
        <span
          className={classes.dot}
          style={{ backgroundColor: getColor(entity) }}
        />
      </div>
    </Tooltip>
  )
}

export default DotStatus
